import {
  Component,
  ChangeDetectionStrategy,
  Output,
  EventEmitter,
  OnInit,
  ChangeDetectorRef,
} from '@angular/core';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { Options } from 'sortablejs';
import {
  IFbPaletteItem,
  getFbFieldPaletteItems,
  getFbWidgetPaletteItems,
} from '../../utils/fb-palette-catalog.util';

@Component({
  selector: 'irembogov-fb-component-palette',
  templateUrl: './fb-component-palette.component.html',
  styleUrls: ['./fb-component-palette.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FbComponentPaletteComponent implements OnInit {
  @Output() addField = new EventEmitter<FormlyFieldConfig>();

  activeTab: 'field' | 'widget' = 'field';
  searchQuery = '';

  fieldTypes: IFbPaletteItem[] = [];
  widgetTypes: IFbPaletteItem[] = [];
  fieldCount = 0;
  widgetCount = 0;

  filteredItems: IFbPaletteItem[] = [];

  paletteSortableOptions: Options = {
    group: {
      name: 'fields',
      pull: 'clone',
      put: false,
    },
    sort: false,
    animation: 200,
    dragClass: 'fb-sortable-drag',
    ghostClass: 'fb-sortable-ghost',
  };

  constructor(private cdr: ChangeDetectorRef) {}

  ngOnInit(): void {
    // Items come from V1's static field/widget lists (see fb-palette-catalog).
    this.fieldTypes = getFbFieldPaletteItems();
    this.widgetTypes = getFbWidgetPaletteItems();
    this.fieldCount = this.fieldTypes.length;
    this.widgetCount = this.widgetTypes.length;
    this.updateFilteredItems();
  }

  onTabChange(tab: 'field' | 'widget'): void {
    this.activeTab = tab;
    this.searchQuery = '';
    this.updateFilteredItems();
  }

  onSearchChange(query: string): void {
    this.searchQuery = query;
    this.updateFilteredItems();
  }

  onItemClick(item: IFbPaletteItem): void {
    // Emit a clone so the catalog template is never mutated by the canvas.
    this.addField.emit(this.cloneConfig(item.config));
  }

  private updateFilteredItems(): void {
    const source =
      this.activeTab === 'field' ? this.fieldTypes : this.widgetTypes;
    const query = this.searchQuery.trim().toLowerCase();
    this.filteredItems = !query
      ? [...source]
      : source.filter(
          item =>
            item.displayName.toLowerCase().includes(query) ||
            item.type.toLowerCase().includes(query)
        );
    this.cdr.markForCheck();
  }

  private cloneConfig(config: FormlyFieldConfig): FormlyFieldConfig {
    return JSON.parse(JSON.stringify(config));
  }

  trackByType(_index: number, item: IFbPaletteItem): string {
    return item.displayName;
  }
}
